

// export const fetchImage = async (imageKey: string): Promise<string | null> => {
//   try {
//     const imageUrl = await getImage(imageKey); 
//     return imageUrl;
//   } catch (err) {
//     console.error("Error fetching or caching image:", err);
//     return null;
//   }
// };

export const fetchImage = async (imageKey: string): Promise<string | null> => {
  try {
    const imageUrl = imageKey
        ? `/teachers_material/images/${imageKey}`
        : null
    return imageUrl;
  } catch (err) {
    console.error("Error fetching or caching image:", err);
    return null;
  }
};

// export const fetchAudio = async (audioKey: string): Promise<string | null> => {
//   try {
//     const audioUrl = await getAudio(audioKey); 
//     return audioUrl;
//   } catch (err) {
//     console.error("Error fetching or caching audio:", err);
//     return null;
//   }
// };

export const fetchAudio = async (audioKey: string): Promise<string | null> => {
  try {
    const audioUrl = audioKey
        ? `/teachers_material/audio/${audioKey}`
        : null
    return audioUrl;
  } catch (err) {
    console.error("Error fetching or caching audio:", err);
    return null;
  }
};
       

export const getLocalStorageSize = () => {
  let totalSize = 0;

  // Loop through all local storage items
  for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);

      // Check if key is not null
      if (key !== null) {
          const value = localStorage.getItem(key);
          // Only proceed if value is not null
          if (value !== null) {
              // Add the size of the key and value
              totalSize += key.length + value.length;
          }
      }
  }

  // Convert size to megabytes (MB)
  return totalSize / (1024 * 1024); // This will be in MB
};


export const formatDate = (date: string | Date): string => {
  const dateObj = date instanceof Date ? date : new Date(date);
  if (isNaN(dateObj.getTime())) return 'Invalid Date'; // Early exit
  
  // Extract date part in UTC to avoid timezone shift
  const dateOnly = dateObj.toISOString().split('T')[0];
  return new Date(dateOnly + 'T00:00:00Z').toLocaleDateString('en-GB').replace(/\//g, '-');
};


  